import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/*
 * @Description: APP下载页场景类型匹配
 * 女娲 downloadPageMap 配置: configValue.data 为 JSON 字符串，解析后为
 * [{ sceneType, campaignIds: number[] }]，按活动id(campaignId)匹配下载页场景值
 */


import QS from 'qs';
import { enums } from '@/const/enums';
import { fetchNvWaConfig } from '@/helpers/nvwa';
import { canJsonParse } from '@/utils'; // 默认下载页场景：一键领课(孩悦)流程固定标识，未命中女娲配置时兜底

export var DEFAULT_DOWNLOAD_SCENE_TYPE = 'childJoy';
/**
 * 匹配下载页场景类型：女娲 campaignIds(数字)与活动id(字符串)统一转字符串比较，
 * 避免类型不一致导致匹配失败；未命中或配置异常返回 null，由调用方兜底 DEFAULT_DOWNLOAD_SCENE_TYPE
 */

export function matchDownloadSceneType(pageMap, campaignId) {
  if (!Array.isArray(pageMap)) return null;
  var matched = pageMap.find(function (item) {
    return item && Array.isArray(item.campaignIds) && item.campaignIds.map(String).includes(String(campaignId)) && item.sceneType;
  });
  return (matched === null || matched === void 0 ? void 0 : matched.sceneType) || null;
} // 模块级缓存：单会话弹窗链路仅涉及一个活动，单条缓存足够；
// 缓存成功命中的匹配值，null 不缓存（点击时可重试）

var sceneTypeCache = null; // in-flight Promise 复用：曝光预取与点击拉取并发时只发一次请求

var sceneTypeFetching = null;
/**
 * 解析下载页场景类型：优先读模块级缓存（同 campaignId 且已有成功匹配值），未命中再拉取
 * 女娲 downloadPageMap(delivererConfigV2) 并按活动id匹配；存在进行中的预取时复用同一
 * Promise，避免曝光预取与点击拉取并发双请求
 * @returns 匹配到的 sceneType；未命中/配置为空/解析失败/拉取异常返回 null，
 *          兜底策略由调用方决定（一键领课链路兜底 childJoy，500011 弹窗链路不携带 sceneType）；
 *          null 结果不写入缓存，调用方可重试
 */

export function resolveDownloadSceneType(campaignId) {
  return __awaiter(this, void 0, void 0, function () {
    var _this = this;

    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (sceneTypeCache && sceneTypeCache.campaignId === campaignId) {
            return [2
            /*return*/
            , sceneTypeCache.sceneType];
          }

          if (sceneTypeFetching) {
            return [2
            /*return*/
            , sceneTypeFetching];
          }

          sceneTypeFetching = function () {
            return __awaiter(_this, void 0, void 0, function () {
              var configValue, pageMap, sceneType, error_1;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    _a.trys.push([0, 2,, 3]);

                    return [4
                    /*yield*/
                    , fetchNvWaConfig('downloadPageMap', {
                      delivererConfig: enums.delivererConfigV2
                    })];

                  case 1:
                    configValue = _a.sent();

                    if (configValue === null || configValue === void 0 ? void 0 : configValue.data) {
                      pageMap = canJsonParse(configValue === null || configValue === void 0 ? void 0 : configValue.data);
                      sceneType = matchDownloadSceneType(pageMap, campaignId); // 仅成功命中的结果进缓存，null 不缓存以便调用方重试

                      if (sceneType) {
                        sceneTypeCache = {
                          campaignId: campaignId,
                          sceneType: sceneType
                        };
                      }

                      return [2
                      /*return*/
                      , sceneType];
                    }

                    return [3
                    /*break*/
                    , 3];

                  case 2:
                    error_1 = _a.sent(); // 女娲获取失败或解析异常，返回 null，不阻断调用方主流程

                    console.error('获取下载页场景配置失败:', error_1);
                    return [3
                    /*break*/
                    , 3];

                  case 3:
                    return [2
                    /*return*/
                    , null];
                }
              });
            });
          }();

          _a.label = 1;

        case 1:
          _a.trys.push([1,, 3, 4]);

          return [4
          /*yield*/
          , sceneTypeFetching];

        case 2:
          return [2
          /*return*/
          , _a.sent()];

        case 3:
          sceneTypeFetching = null;
          return [7
          /*endfinally*/
          ];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
}
/**
 * 曝光预取入口（fire-and-forget）：弹窗展示时调用，用户阅读弹窗期间完成网络请求，
 * 成功命中后结果进入模块级缓存，onOk 时免网络等待
 */

export function prefetchDownloadSceneType(campaignId) {
  // fire-and-forget：函数内部已 try/catch 兜底，Promise 不会 reject，无需等待
  resolveDownloadSceneType(campaignId);
}
/**
 * 同步读取模块级缓存（供 onOk 判断，命中时不产生任何网络等待）
 * @returns 缓存的 sceneType；无缓存或该活动未成功命中过时返回 null
 */

export function getCachedDownloadSceneType(campaignId) {
  return sceneTypeCache && sceneTypeCache.campaignId === campaignId ? sceneTypeCache.sceneType : null;
}
/**
 * 纯 URL 组装（同步、无副作用）：downloadUrl + campaignId + linkId + sceneType，
 * downloadUrl 含 '?' 时用 '&' 拼接；sceneType 为空值时该参数整体省略
 */

export function buildDownloadPageUrl(campaignId, linkId, sceneType) {
  var downloadUrl = enums.schema.downloadUrl; // sceneType 仅在命中配置或调用方显式指定兜底时携带；null/undefined 时参数整体省略

  var params = QS.stringify(__assign({
    campaignId: campaignId,
    linkId: linkId
  }, sceneType ? {
    sceneType: sceneType
  } : {}));
  var separator = downloadUrl.includes('?') ? '&' : '?';
  return "".concat(downloadUrl).concat(separator).concat(params);
}
/**
 * resolve + build 组合（一键领课链路使用）：动态匹配后组装完整 URL，
 * 未命中时使用 fallbackSceneType（默认 null 表示 URL 不携带 sceneType 参数）
 */

export function resolveDownloadPageUrl(campaignId, linkId, fallbackSceneType) {
  return __awaiter(this, void 0, void 0, function () {
    var sceneType;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , resolveDownloadSceneType(campaignId)];

        case 1:
          sceneType = _a.sent() || fallbackSceneType;
          return [2
          /*return*/
          , buildDownloadPageUrl(campaignId, linkId, sceneType)];
      }
    });
  });
}